module.exports = __webpack_public_path__ + "static/media/contact.4ee8d6c9.svg";